import React, { useState, useEffect } from "react";
import Header from "../Header";
import { useParams } from "react-router-dom";
import axios from "axios";
import { path, ENV } from "../../../path.js";
import { AntIcon , Thumbnail, Intro_Thumbnail} from "../icons";
import VideoPlayer from "../VideoPlayer.js";
import { ContestImage } from "../icons";
import { IoLocationOutline } from "react-icons/io5";
import { FaClockRotateLeft } from "react-icons/fa6";
import { FaRegImage, FaRegLightbulb } from "react-icons/fa";
import { PiMedalBold } from "react-icons/pi";
import { MdOutlineVerified } from "react-icons/md";
import { useHistory } from "react-router-dom";
import { useDisclosure } from "@chakra-ui/react";
import { Modal } from "antd";
import { EventTypes, trackEvent } from "../../../Utils/Analytics.js";

function UserProfile() {
  const { id: userId } = useParams();
  const [searchedUser, setSearchedUser] = useState(null);
  const [judgeData, setJudgeData] = useState(null);
  const [judgedContests, setJudgedContest] = useState([]);
  const [showAcheivement, setShowAcheivement] = useState(false);
  const [totalPostCount, setTotalPostCount] = useState(0);
    const {
      isOpen: isImageModal,
      onOpen: openImageModal,
      onClose: closeImageModal,
    } = useDisclosure();
  const [selectedImage, setSelectedImage] = useState(null)
  const history = useHistory();

  const getUser = async () => {
    try {
      if (userId) {
        const response = await axios.get(`${path}/getUserData/${userId}`);
        if (!response.data) {
          throw new Error("User does not exist!");
        }
        setSearchedUser(response?.data);
      }
    } catch (error) {
      console.log("error in getting searched user", error);
    }
  };

  const getJudgeData = async (judgeId) => {
    const response = await axios.get(`${path}/getApplicantById/${judgeId}`);

    if (response?.data?.judge) {
      setJudgeData(response.data.judge);
    }
  };

  const getJudge = async (userId) => {
    const response = await axios.get(`${path}/getjudge/${userId}`);
    console.info("Judge API check ", response?.data);

    if (response?.data?.message === "Judge field populated successfully") {
      setJudgedContest(response?.data?.judge);
    }
  };

  const getTotalPostsCount = async (id) => {
  try {
    if (id) {
      const res = await axios.get(
        `${path}/totalPosts/${id}`
      );
      if(res?.data?.totalPosts){
        setTotalPostCount(res?.data?.totalPosts);
      }
    }
  } catch (error) {
    console.log("Totalpost error : ", error);
  }
  };

  const handleImageOpen = (url) =>{
    setSelectedImage(url)
    openImageModal();
  }

  useEffect(() => {
    if (searchedUser?.judgeData) {
      getJudgeData(searchedUser?.judgeData);
      getJudge(searchedUser?._id);
      getTotalPostsCount(searchedUser?._id);
    }
    if(ENV === "prod" && searchedUser?._id){
      trackEvent(EventTypes.JUDGE_VISIT,{
        judgeId: searchedUser?._id,
        judgeUsername: searchedUser?.username
      });
    }
    
  }, [searchedUser]);

  useEffect(() => {
    getUser();
  }, [userId]);

  return (
    <div className=" h-svh w-full fixed inset-0 overflow-y-scroll bg-slate-100 font-gilroy-regular">
      {/* Header */}
      <Header />

      {!searchedUser ? (
        <div className=" flex items-center justify-center w-full h-full">
          <div className="size-10 border-3 border-teal-700 border-t-white rounded-full animate-spin" />
        </div>
      ) : (
        <>
          {/* Bottom Section  */}
          <div className=" w-full ">
            {/* Cards container  */}
            <div className=" w-full flex my-20 justify-around">
              {/* Main Card  */}
              <div className=" w-full max-w-md flex flex-col gap-4 px-2">
                <div className=" bg-white w-full rounded-lg relative shadow-xl py-8 flex flex-col gap-2">
                  {/* Profile Image  */}
                  <div className="w-full flex justify-center bg-white rounded-full">
                    <img
                      src={searchedUser?.profilePicture || AntIcon}
                      alt="user-image"
                      className=" absolute -top-10 size-24 rounded-full bg-white border-2 shadow-2xl border-gray-200"
                    />
                  </div>

                  <div
                    className={`flex flex-col items-center justify-center  py-4 gap-2 ${judgeData && "border-b-2 border-b-gray-200"}`}>
                    <h1 className=" text-xl font-bold">
                      {searchedUser?.username}
                    </h1>
                    {judgeData && judgeData.status === "approved" && (
                      <div className=" px-6 py-2 rounded-lg bg-teal-700 flex items-center gap-2 ">
                        <PiMedalBold size={20} color="#FFC107" />
                        <span className="text-white font-medium "> Judge </span>
                      </div>
                    )}
                  </div>

                  {judgeData && (
                    <div className=" flex items-center justify-around flex-wrap gap-1">
                      <span className=" px-6 py-2 font-semibold  bg-slate-100  rounded-xl">
                        {judgeData?.skill_category}
                      </span>
                      
                      <span className=" px-6 py-2 font-semibold  bg-slate-100 border rounded-xl">
                        {judgeData?.experienceYears} Years Exp
                      </span>

                      <span className=" px-6 py-2 font-semibold  bg-slate-100 border rounded-xl ">
                        {judgeData?.skill_subcategory}
                      </span>
                    </div>
                  )}

                  {judgeData && (
                    <div className=" px-4 mt-4">
                      <VideoPlayer
                        src={searchedUser?.judgeVideo}
                        alt="intro_video"
                        className="h-48 w-full object-cover"
                        poster={Intro_Thumbnail}
                      />
                    </div>
                  )}
                </div>

                {/* Acheivements  */}
                {judgeData && (
                  <div className=" bg-white w-full rounded-lg relative shadow-xl p-4 flex flex-col gap-2">
                    <h1 className="text-lg font-semibold ">Acheivements</h1>
                    <p
                      className={` text-gray-600 font-medium ${!showAcheivement && "line-clamp-4"}`}>
                      {judgeData?.achievements[0]}
                    </p>
                    {judgeData?.achievements[0]?.length > 45 && (
                      <span
                        className="text-blue-500 font-medium underline text-end text-sm cursor-pointer"
                        onClick={() => setShowAcheivement((prev) => !prev)}>
                        {showAcheivement ? "Show less" : "Show more"}
                      </span>
                    )}
                  </div>
                )}

                {/* qualifications  */}
                {judgeData?.qualifications?.length > 0 && (
                  <div className=" bg-white w-full rounded-lg relative shadow-xl p-4 flex flex-col gap-2" >
                    <h1 className="text-lg font-semibold">
                      Degree/Certifications
                    </h1>
                    {judgeData?.qualifications?.map((item) => (
                      <img
                        key={item?.file_id}
                        src={item.file_url}
                        alt="Degree"
                        className="w-full h-48 rounded-lg border border-gray-200"
                        onClick={()=>handleImageOpen(item?.file_url)}
                      />
                    ))}
                  </div>
                )}

                {/* Featured Work  */}
                {judgeData?.featured_work_links?.length > 0 && (
                  <div className=" bg-white w-full rounded-lg relative shadow-xl p-4 flex flex-col gap-2">
                    <h1 className="text-lg font-semibold">Featured Work</h1>
                    {judgeData?.featured_work_links?.map((link) => (
                      <div className=" flex items-center gap-2" key={link}>
                        <span className=" text-blue-500">
                          <MdOutlineVerified size={20} />
                        </span>
                        <a
                          href={link}
                          target="blank"
                          className=" text-blue-600 font-medium underline text-sm truncate">
                          {link}
                        </a>
                      </div>
                    ))}
                  </div>
                )}

                {/* Signature Videos  */}
                {judgeData?.signature_videos?.length > 0 && (
                  <div className=" bg-white w-full rounded-lg relative shadow-xl p-4 flex flex-col gap-2">
                    <h1 className="text-lg font-semibold">Signature Videos</h1>
                    {judgeData?.signature_videos?.map((item) => (
                      <VideoPlayer
                        src={item?.video_url}
                        key={item?.video_id}
                        poster={Thumbnail}
                        alt="signature_video"
                        className="h-48 w-full object-cover"
                      />
                    ))}
                  </div>
                )}

                {/* Currently Judging Competions  */}
                {judgedContests.length > 0 && (
                  <div className="bg-white w-full rounded-lg relative shadow-xl  flex flex-col gap-2">
                    <div className="flex flex-row justify-between mb-3 p-4 border-b border-b-gray-200">
                      <h1 className="text-lg font-semibold">
                        Currently Judging Contests
                      </h1>
                    </div>
                    <div className="p-2">
                      {judgedContests.map((item, index) => {
                        const contestTitle =
                          item.sections[2]?.fields[0]?.response;
                        const contestImg =
                          item.sections[1]?.fields[0]?.response;
                        const eventId = item._id;
                        const eventType = item.sections[2]?.fields[2]?.response;

                        if (eventType !== "Solo") {
                          return null;
                        }

                        return (
                          <div
                            key={contestTitle}
                            className={`bg-gray-50 p-1 rounded-md ${
                              index !== judgedContests.length - 1
                                ? "mb-2.5"
                                : ""
                            }`}>
                            <button
                              onClick={() => {
                                if (eventType === "Solo") {
                                  history.push(`/contest/${eventId}`);
                                }
                              }}
                              className="flex flex-row items-center px-2 py-1.5 w-full text-left">
                              <img
                                src={contestImg || ContestImage}
                                alt="contest"
                                className="h-12 w-24 rounded-xl"
                              />

                              <p className="ml-3  font-semibold text-gray-800">
                                {contestTitle}
                              </p>
                            </button>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}

                <div className=" bg-white w-full rounded-lg relative shadow-xl p-4 flex flex-col gap-4">
                  <div className=" flex items-center justify-between ">
                    <div className=" flex items-center gap-2 text-gray-600">
                      <IoLocationOutline size={20} fontSize={500} />
                      <p className=" font-medium">Location</p>
                    </div>

                    <h2 className=" text-lg font-medium ">
                      {searchedUser?.country || "India"}
                    </h2>
                  </div>
                  <div className=" flex items-center justify-between ">
                    <div className=" flex items-center gap-2 text-gray-600">
                      <FaClockRotateLeft size={20} />
                      <p className="  font-medium">Member Since</p>
                    </div>

                    <h2 className=" text-lg font-medium ">
                      {searchedUser?.createdAt?.slice(0, 4)}
                    </h2>
                  </div>
                  <div className=" flex items-center justify-between ">
                    <div className=" flex items-center gap-2 text-gray-600">
                      <FaRegImage size={20} />
                      <p className=" font-medium">Total Post</p>
                    </div>

                    <h2 className=" text-lg font-medium ">{totalPostCount || 0}</h2>
                  </div>
                  <div className=" flex items-center justify-between ">
                    <div className=" flex items-center gap-2 text-gray-600">
                      <FaRegLightbulb size={20} />
                      <p className="  font-medium">Your Skills</p>
                    </div>

                    <h2 className=" text-lg font-medium ">
                      {(searchedUser?.professionalSkills?.length +
                        searchedUser?.unprofessionalSkills?.length) || 0}
                    </h2>
                  </div>
                </div>
              </div>

              {/* Image Modal */}
              <Modal
                open={isImageModal}
                onCancel={closeImageModal}
                footer={null}
                centered
                width="auto"
                style={{ padding: 0 }}
                bodyStyle={{ padding: 0, display: "flex", justifyContent: "center", alignItems: "center" }}
              >
                <img
                  src={selectedImage}
                  alt="Degree"
                  className="rounded-lg border border-gray-200 max-w-full h-auto"
                  style={{ maxHeight: "80vh" }} 
                />
              </Modal>

            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default UserProfile;
